<template>
  <div class="box6">
    <pageTitle
      title="学生权益"
    />
    <div class="subject-box">
      <div class="scorll-box6">
        <div class="nav-box">
          <div
            class="nav"
            :class="{ 'cur-nav': cur == index }"
            v-for="(item, index) in projectList"
            :key="index"
            @click="changeCur(index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div>
        <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
          <swiper-slide
            class="swiperwrap"
            v-for="(item, index) in projectList"
            :key="index"
          >
            <div class="wrap">
              <img class="img" :src="item.img" alt="" />
              <div class="projectName"><img
                    class="title-left"
                    src="../../../assets/coursePage/mba/box6/left.png"
                  />{{ item.title }}<img
                    class="title-left"
                    src="../../../assets/coursePage/mba/box6/right.png"
                  /></div>
              <div class="projectDesc">{{ item.exp }}</div>
             
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    let that = this;
    return {
     
      projectList: [
        {
          name: "权益一",
          title: "学生ID&学生邮箱",
          exp: "学员入学后即可获得唯一的学生ID和带有院校后缀的学生邮箱。学员在正式入学后可以正式激活学生邮箱，并获得专属的账号与密码，用于登录院校内网。学生邮箱在学员毕业后能够继续使用。",
          img: require("../../../assets/coursePage/mba/box6/img01.png"), 
        },
        {
          name: "权益二",
          title: "专属的学生卡",
          exp: "学员在正式入学后2-3月将会收到专属的学生卡。学员可以使用学生卡享受多数电子产品商家所提供的教育优惠购买政策，包括苹果 (Apple) 、联想 (Lenovo))、微软 (Microsoft) 等。",
          img: require("../../../assets/coursePage/mba/box6/img02.png"), 
        },
        {
          name: "权益三",
          title: "开具证明文件",
          exp: "学员在读期间可以向校方申请开具在读证明、成绩单等文件。有过往的在读学员通过展示自己的在读证明，助力其成功获得面试公司的认可并获得更好工作机会。",
          img: require("../../../assets/coursePage/mba/box6/img03.png"), 
        },
        {
          name: "权益四",
          title: "个人学籍信息查询",
          exp: "无论是在读期间或是毕业后，学员均可以通过院校内网登录学生账号查询自己的学籍信息、学习记录、以及学位证书真实性。",
          img: require("../../../assets/coursePage/mba/box6/img04.png"), 
        },
        {
          name: "权益五",
          title: "学生专属的大量IT资源",
          exp: "学员在读期间可以通过学生账号获取大量IT资源，大量的付费软件都可以使用学校的账号登录并激活，例如Adobe全家桶、Office、Windows、SQL Server、Visio、Visual Studio。",
          img: require("../../../assets/coursePage/mba/box6/img05.png"), 
        },
        {
          name: "权益六",
          title: "线上图书馆",
          exp: "学员在读期间可以随时登录学校的线上图书馆，免费下载和查阅大量文献和书籍。",
          img: require("../../../assets/coursePage/mba/box6/img06.png"), 
        },
       
        {
          name: "权益七",
          title: "加入GGU校友会",
          exp: "金门大学拥有丰富优质的全球校友资源，培养出众多在全球有知名度于影响力的政商界人士。学员毕业后可加入GGU校友会，有机会与其他校友建立联系，推荐优秀校友，参与分享会等校友活动。",
          img: require("../../../assets/coursePage/mba/box6/img07.png"), 
        },
        {
          name: "权益八",
          title: "学位证书",
          exp: "学员毕业后可获得由院校颁发的硕士学位证书，书写样式、含金量与美国线下学员完全一致，证书全球认可。",
          img: require("../../../assets/coursePage/mba/box6/img08.png"), 
        },
      ],
      cur: 0,
      scroll: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box5",
        },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            document.getElementsByClassName("nav-box")[0].scrollLeft =
              this.realIndex * 85;
          },
          click(e) {
            if (e.target.className == "open") {
              that.show = true;
            }
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },

    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  methods: {
  showPop(){
  this.show = true,
       this.mai("JavaEE-就业课","查看全部",0,this.projectList[this.cur].title)
  },
    changeCur(index) {
      this.swiper.slideTo(index, 0, false);
      this.cur = index;
    },
    close() {
      this.showVideo = false;
    },
  },
};
</script>

<style lang="less" scoped>
.box6 {
  padding: 80px 0 0;
  width: 100%;
  background: url("../../../assets/coursePage/mba/box6/bg.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  height: 1040px;
  box-sizing: border-box;
  .van-popup {
    max-height: calc(100vh - 80px);
  }
  .subject-content {
    overflow-x: scroll;
    width: 100%;
    height: 234px;
    // background: url("../../../assets/coursePage/java/box5/content.png")
    //   no-repeat;
    // background-size: cover;
    display: flex;
    overflow-y: hidden;
    align-content: center;
    margin: 48px 0;
    .left {
      background: url("../../../assets/coursePage/java/box5/leftBgc.png")
        no-repeat;
      background-size: cover;
      width: 262px;

      height: 236px;
      flex-shrink: 0;
      p {
        height: 72px;
        width: auto;
        background-size: cover;
        box-shadow: 0px 0px 36px 0px rgba(20, 50, 74, 0.08);
        position: relative;
        margin-right: 20px;
        font-weight: 600;
        color: #165dff;
        border: 0;
        box-shadow: none;
        font-size: 28px;
        font-family: PingFang SC;
      }
      p:nth-child(1) {
        margin-left: 70px;
        margin-top: 53px;
      }
      p:nth-child(2) {
        margin-left: 70px;
        margin-top: 20px;
      }
    }
    .right {
      display: flex;
      align-content: center;
      flex-wrap: wrap;
    }
    .firstRow,
    .secondRow {
      position: relative;
      display: flex;
      margin-left: -20px;
      .item {
        flex-shrink: 0;
        height: 72px;
        background: rgba(255, 255, 255, 0.4);
        box-shadow: 0px 0px 36px 0px rgba(20, 50, 74, 0.08);
        border-radius: 8px;

        padding: 0 36px;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
        margin-right: 20px;
        line-height: 72px;
      }
    }
    .secondRow {
      margin-top: 20px;
      margin-right: 20px;
    }
  }
  .subject-content::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .nav-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .scorll-box {
    position: absolute;
    left: 50%;
    margin-top: 32px;
    transform: translate(-50%, 0px);
    width: 78px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: 20px;
      height: 6px;
      background: #4b84fa;
      border-radius: 3px;
    }
  }
  .subject-box {
    position: relative;
    margin:48px auto 0;
    // padding-bottom: 22px;
    width: 100%;
    overflow: hidden;
    .swiperwrap {
      width: 686px;
padding-bottom: 0;
    
      .wrap{
        padding:36px 24px 24px;
      }
      img {
        width: 100%;
       
        object-fit: cover;
        border-radius: 16px;
      }
      .projectName {
       
        font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 28px;
color: #E55F33;
line-height: 40px;
text-align: center;
font-style: normal;
        margin: 24px auto;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 20px;
          height: 18px;
          margin: 0 16px;
        }
      }
      .projectDesc {
        font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 24px;
color: #3C3937;
line-height: 40px;
text-align: justify;
font-style: normal;
       
      }
      
    }

    .scorll-box6 {
      overflow-x: scroll;
      transition: all 0.2s;
      width: 100%;

      box-sizing: border-box;
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
        height: 0 !important;
        color: transparent;
      }
    }
    .nav-box {
      height: 103px;
      display: flex;
      justify-content: space-between;

      position: relative;
      display: flex;
      justify-content: space-between;
      overflow-x: scroll;
      transition: all 0.2s;
      padding: 0 26px;
      .nav {
        width: 138px;
        height: 71px;
        background: #ffffff;
        border-radius: 8px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 71px;
        text-align: center;
        margin-right: 16px;
        flex-shrink: 0;
      }

      .cur-nav {
        background: linear-gradient( 270deg, #E2895E 0%, #E65A2E 100%);

        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;

        position: relative;
      }
    }
  }

  .swiper-slide {
    // padding: 0px 40px;
    padding-bottom: 74px;

    .block {
      position: relative;
      margin: 0 auto;
      padding: 36px 32px;
      width: 686px;
      height: 688px;
      background: #ffffff;
      box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      border: 1px solid #ffffff;
      background-size: contain;
      background-repeat: no-repeat;
      // box-sizing: border-box;

      .open {
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        width: 100%;
        height: 140px;
        // background: #fff;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 40%,
          #fff 100%
        );
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 36px;
        box-sizing: border-box;

        img {
          margin-left: 8px;
          width: 32px;
          height: 32px;
        }
      }

      overflow: hidden;
      box-sizing: border-box;

      .block-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        height: 56px;
        .title {
          font-size: 28px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #1d2129;
        }

        .play-btn {
          display: flex;
          align-items: center;
          width: 180px;
          height: 56px;
          background: linear-gradient(313deg, #1fd7cd 0%, #65bcff 100%);
          box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
          border-radius: 32px;

          font-size: 24px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #ffffff;

          .play {
            margin-left: 8px;
            margin-right: 12px;
            width: 40px;
            height: 40px;
            background-color: #ffffff;
            border-radius: 50%;
            box-shadow: 0px 0px 6px 0px #28a9ea;
            background-image: url("../../../assets/coursePage/ai/box8/play.png");
            background-size: 24px 24px;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .into {
        margin-bottom: 24px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
      }
    }
  }

  .swiper-pagination-box5 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    transform: translate(-50%, 0px);
    background: rgba(75, 132, 250, 0.16);

    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #4b84fa;
    border-radius: 3px;
  }

  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 56px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;
      height: 132px;
      padding-top: 16px;
      background: #fff;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }
    .exp {
      font-size: 26px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 44px;
      margin-bottom: 8px;
    }
    .intro {
      margin: 0px 0 40px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }

    .demo {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      p {
        display: flex;
        align-items: center;

        span {
          margin-right: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #00a8ff;
        }
      }
    }

    .tag {
      margin-bottom: 24px;
      width: 170px;
      height: 56px;
      background: #e8f1ff;
      border-radius: 0px 32px 32px 24px;
      font-size: 28px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      text-align: center;
      color: #2674ff;
      line-height: 56px;
    }

    .target {
      margin-bottom: 64px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      p {
         padding-left: 15px;
          position: relative;
        &::before {
          content: "";
          width: 4px;
          height: 4px;
          background: #4e5969;

          border-radius: 50%;

          top: 20px;
          display: block;
          position: absolute;
          left: 0;
        }
      }
    }
  }
}
</style>
